import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { roleType } from "../../constant/constants";
import { isCompanyPrivileged } from "../../utils/roleUtils";

const TrainingCatalogue = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const localUser = JSON.parse(localStorage.getItem("sdfUser"));
  const userRole = localUser?.role;

  useEffect(() => {
    // Handle backward compatibility with location.state.activeTab
    if (location.state?.activeTab) {
      const activeTab = location.state.activeTab;
      if (activeTab === "CompanyCatalogue") {
        navigate("/company-catalogue", { replace: true });
      } else if (activeTab === "IFundiCatalogue") {
        navigate("/ifundi-catalogue", { replace: true });
      } else if (activeTab === "CriticalSkills") {
        navigate("/critical-skills", { replace: true });
      } else {
        // Default redirect based on role
        const defaultRoute = isCompanyPrivileged(userRole)
          ? "/company-catalogue"
          : "/ifundi-catalogue";
        navigate(defaultRoute, { replace: true });
      }
    } else {
      // Default redirect based on role
      const defaultRoute = isCompanyPrivileged(userRole)
        ? "/company-catalogue"
        : "/ifundi-catalogue";
      navigate(defaultRoute, { replace: true });
    }
  }, [navigate, location.state?.activeTab, userRole]);

  return null;
};

export default TrainingCatalogue;
